<template>
  <div class="client-item-box new-image" :id="'nofixNav'+data.nofixNavId+'-'+data.nofixNavIndex" v-if="images && images.length" :data-trackdata="tData">
    <div class="new-image-box">
      <div class="new-image-items" :style="{height: `${maxHeight}px`}">
      
        <div class="img-box" 
          v-for="(item, index) in images" 
          :key="index" 
          :style="{width: `${item.widthNum}px`, height: `${maxHeight}px`, left: `${item.left}`}"
        >
          <div class="img-item" 
            :class="videowrap(index)" 
            :style="{width: `${item.widthNum}px`, height: `${item.heightNum}px`, borderRadius: `${radius}`}"
            @click="mediaAction(item, index)"
          >
            <beast-image
              class="img" 
              v-if="item.type === 'image'"
              :lazy="true"
              :image="item.image"
              :containerWidth="item.widthNum"
            />
            <beast-video
              v-if="item.type === 'video'"
              :wrap="item.wrapIndex"
              :height="item.heightNum"
              :poster="item.poster"
              :autoplay="item.autoplay"
              :source="item.source"
              :controls="item.controls"
              :videoFormat="item.videoFormat"
              :muted="item.muted"
              :radius="radius"
              :multiVideo="multiVideo"
              :videoPopData="item"
              @video-pop="videoPopAction"
            />
          </div>
        </div>

      </div>
    </div>

    <video-pop
      v-if="videoPopFlag"
      :data="videoPopData"
      :radius="radius"
      @close="closeAction"
    />
  </div>
</template>

<script>
import { ensure_protocol } from '@beastshop/url-util'
import { getClientWidth, trackAction } from '../lib/util.js'
import { transformLink, normalSkip, getToMiniLink, getLinkPageData } from '@/link'

import beastImage from '@/components/image'
import beastVideo from '@/components/video'
import videoPop from './video-pop.vue'
import { zipImage } from '@/util'

const clientWidth = getClientWidth()
const ratio = clientWidth/375

export default {
  name: 'new-image',
  // props: ['data'],
  props: ['data', 'modIndex', 'memberTags', 'sdk', 'miniEnv', 'multiVideo', 'isApp', 'pageType'],
  components: {
    beastImage,
    beastVideo,
    videoPop
  },
  data () {
    return {
      lineGap: 0,
      imgBoxWidth: 0,
      images: null,
      maxHeight: 0,
      pl: 0,
      pr: 0,
      pt: 0,
      pb: 0,
      radius: 0,
      videoPopData: null,
      videoPopFlag: false,
      tData: JSON.stringify(this.data.trackData || {})
    }
  },
  mounted() {
  },
  computed: {
    // styleObj () {
    //   return {
    //     'padding-left': `${ratio*this.pl}px`,
    //     'padding-right': `${ratio*this.pr}px`,
    //     'padding-top': `${ratio*this.pt}px`,
    //     'padding-bottom': `${ratio*this.pb}px`
    //   }
    // }
  },
  created() {
    this.getImages()
  },
  methods: {
    videowrap (index) {
      return `wrap${this.modIndex}-${index}`
    },
    getImages () {
      console.log('new-image')
      const tags = this.memberTags || []
      if((this.data.customer !== 'ALL' && this.data.customer !== 'DELINEATION' && tags.indexOf(this.data.customer) === -1) || (this.data.customer === 'DELINEATION' && tags.indexOf(this.data.customerCode) === -1)) {
        return
      }

      // const pl = this.data.leftPadding?Number(this.data.leftPadding):0
      // const pr = this.data.rightPadding?Number(this.data.rightPadding):0
      // const pt = this.data.topPadding?Number(this.data.topPadding):0
      // const pb = this.data.bottomPadding?Number(this.data.bottomPadding):0
      // this.pl = pl
      // this.pr = pr
      // this.pt = pt
      // this.pb = pb
      const {
        pl,
        pr
      } = this.data.paddingData

      const items = this.data.items || []
      if(!items || items.length === 0) {
        return []
      }

      const newItems = []
      let widthItems = []
      let widthValue = 0
      items.forEach(item => {
        if(item.media && item.media.src) {
          if(item.imageWidth) {
            widthItems.push(Number(item.imageWidth))
          }
          newItems.push(item)
        }
      })

      widthItems.forEach(width => {
        widthValue += width
      })

      this.lineGap = this.data.lineGap?Number(this.data.lineGap):0
      this.imgBoxWidth = 375-pl-pr
      this.radius = this.data.radius?`${Number(this.data.radius)*ratio}px`:0
      
      const len = newItems.length
      const widthLen = widthItems.length
      let perWidth = 0
      if(len-widthLen > 0) {//未填写宽度的图片宽度
        perWidth = (this.imgBoxWidth-(len-1)*this.lineGap-widthValue)/(len-widthLen)
      }
      if(perWidth <= 0) {
        perWidth = 0
      }
      
      const images = []
      let maxHeight = 0
      newItems.forEach((item, index) => {
        const url = item.media.src
        const stuffIndex = url.lastIndexOf('.')
        const stuff = url.substring(stuffIndex).toLowerCase()
        const type = (stuff === '.mp4')?'video':'image'

        let image = {
          type,
          image: item.media,
          toMiniProgram: item.toMiniProgram,
          link: item.link,
          trackTitle: item.trackTitle,
          trackServiceType: item.trackServiceType
        }
        const widthNum = item.imageWidth?Number(item.imageWidth)*ratio:perWidth*ratio
        image['widthNum'] = widthNum

        if(type === 'image') {
          image['heightNum'] = (widthNum/item.media.width)*item.media.height
          image['width'] = item.imageWidth?`${Number(item.imageWidth)*ratio}px`:`${perWidth*ratio}px`
        }

        if(type === 'video') {
          const videoMode = this.data.videoMode
          image['wrapIndex'] = `wrap${this.modIndex}-${index}`
          image['wrapPopIndex'] = `wrap${this.modIndex}-${index}-1`
          const poster = zipImage(item.poster)
          image['poster'] = poster && ensure_protocol(poster.src)
          image['source'] = item.media && ensure_protocol(item.media.src)
          image['heightNum'] = item.poster?((widthNum/item.poster.width)*item.poster.height):((widthNum/item.media.width)*item.media.height)
          // image['height'] = (widthNum/item.poster.width)*item.poster.height//弹框视频
          image['muted'] = (this.data.videoVoice === 'OPEN')?'':'muted',
          image['videoMode'] = videoMode
          image['videoFormat'] = this.data.videoFormat
          image['autoplay'] = (videoMode==='AUTO' || videoMode==='CONTROL')?true:false
          image['controls'] = videoMode==='AUTO'?false:true
        }

        let leftNum = 0
        if(index > 0) {
          for(let i=index;i>0;i--) {
            leftNum += images[i-1]?(images[i-1].widthNum+this.lineGap*ratio):0
          }
        }
        image['leftNum'] = leftNum
        image['left'] = `${leftNum}px`

        if(image.heightNum > maxHeight) {
          maxHeight = image.heightNum
        }

       images.push(image)
      })

      console.log(images, "images")
      this.maxHeight = maxHeight
      this.images = images
    },
    mediaAction (item, index) {
      if(this.pageType === 'index' && item.type === 'video') {//首页视频 不允许跳转
        return
      }
      if(this.pageType === 'article' && item.type === 'video' && item.videoMode !== 'AUTO') {//专题页 非背景自动播放视频 不允许跳转
        return
      }

      const link = item.link
      if(!link.type || link.type === 'none') {
        return
      }

      let myLink = ''
      let toMiniFlag = false
      if(this.isApp && item.toMiniProgram) {//app环境 且 在app打开小程序页面
        myLink = getToMiniLink({
                link: item.link
              })
      }
      if(myLink) {
        toMiniFlag = true
      }
      if(!myLink) {
        myLink = transformLink({
                link: item.link,
                isMini: this.miniEnv
              })
      }
      // console.log(item, '#######item')
      const trackData = this.data.trackData
      trackData.module_number = index-0+1
      trackData.operation_name = item.trackTitle
      trackData.operation_type = item.trackServiceType || ''
      trackAction({
        trackData,
        pageObj: getLinkPageData({
          link: item.link
        })
      })
      // console.log(trackData, '#######')

      normalSkip({
        link: myLink,
        isMini: this.miniEnv,
        toMiniProgram: toMiniFlag
      })
    },
    videoPopAction (data) {
      this.videoPopData = data
      this.videoPopFlag = true
    },
    closeAction () {
      this.videoPopFlag = false
    },

  }
}
</script>



// WEBPACK FOOTER //
// new-image.vue?7a350e16